import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen bg-background grid place-items-center px-6 py-16"
      data-testid="not-found-page">
      <div className="max-w-md text-center">
        <p className="font-display text-7xl sm:text-8xl tracking-tight text-oxblood/30 leading-none">404</p>
        <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood font-medium mt-6 mb-3">— Off the rack</p>
        <h1 className="font-display text-3xl sm:text-4xl">This piece isn't in the archive.</h1>
        <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
          The page you're looking for has been moved, removed, or never existed. Let's get you back somewhere useful.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/app"
            data-testid="not-found-app"
            className="px-5 py-2.5 bg-oxblood hover:bg-oxblood-deep text-ivory text-sm">
            Back to dashboard
          </Link>
          <Link to="/"
            data-testid="not-found-home"
            className="px-5 py-2.5 border border-foreground/20 hover:bg-bone text-sm">
            Visit homepage
          </Link>
        </div>
      </div>
    </main>
  );
}
